module.exports = new __parcel__URL__("svg-user-not-found_ptc.0205a184.svg").toString();